module.exports = __webpack_public_path__ + "static/tanan-fb1fdecd317b8b91d633a49531bc360d.jpg";